export const ContainerLogoOverlay = tw.div`
absolute bottom-0 left-0 flex items-end justify-start p-6 md:p-8 z-10
`;
import tw from "tailwind-styled-components";

export const ContainerHome = tw.div`
w-full max-w-full overflow-x-hidden
flex flex-col md:flex-row
min-h-screen
`;

export const ContainerLeft = tw.div`
relative
w-full md:w-3/5
min-h-screen
after:absolute after:inset-0 after:bg-black/75 after:z-[1] after:pointer-events-none
`;

export const ContainerLeftMap = tw.div`
relative
w-full md:w-3/5
min-h-screen
bg-app
`;

export const BackgroundImg = tw.img`
w-full h-full min-h-screen min-w-full
object-cover absolute z-0 top-0 left-0 bottom-0 right-0
`;
export const ContainerLogin = tw.div`
flex items-start justify-center
bg-app
w-full md:w-2/5
min-h-screen md:h-full
rounded-2xl md:rounded-none shadow-lg md:shadow-none
border border-line md:border-y-0 md:border-r-0
px-4 sm:px-6 md:p-0
overflow-y-auto
absolute md:static inset-0 md:inset-auto m-auto md:m-0 max-w-full md:max-w-none z-10
transition-colors duration-300
`;

export const ContainerLogo = tw.div`
w-fit h-[90%]
flex flex-col justify-center 
gap-5 pl-24
`;

export const Logo = tw.img`
w-60
`;

export const ContainerSlogan = tw.div`
flex items-center
`;

export const Line = tw.hr`
flex-grow mr-3
border-t border-white 
`;

export const Slogan = tw.p`
text-sm text-white font-bold
`;

export const MainContainer = tw.div`
w-full 
flex flex-col items-center
`;

export const HomeSlogan = tw.p`
text-base text-white font-bold
`;

export const HomeLogoImage = tw.img`
w-24
`;

export const ContainerRight = tw.div`
w-[300px] md:w-[450px]  px-8 md:px-12 bg-gray-50
rounded-xl
`;
